import React, { useState } from "react";
import { Dialog } from "../../../../Shared/Modal/Dialog";
import { AtticusCheckBox } from "../../../../Shared/Form";

// LocalStorage key for the "don't show again" preference
export const PASTE_FORMATTING_POPUP_KEY = "atticus-paste-formatting-popup-disabled";

/**
 * Component for the dialog content that manages the checkbox state
 */
interface PasteFormattingContentProps {
  onDontShowAgainChange: (checked: boolean) => void;
}

const PasteFormattingContent: React.FC<PasteFormattingContentProps> = ({ onDontShowAgainChange }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleDontShowAgain = (e: any) => {
    const checked = e.target.checked;
    setDontShowAgain(checked);
    onDontShowAgainChange(checked);
  };

  return (
    <div>
      <p>
        Atticus spotted some formatting hiccups in your pasted text that might have caused some trouble during export—and could have even led
        to rejection from retailers like Amazon. Don’t worry, we tidied it up for you, so you should be good to go.
      </p>
      <br />
      <AtticusCheckBox
        type="secondary"    
        checked={dontShowAgain}
        onChange={handleDontShowAgain}
        label="Don't show me this again"
      />
    </div>
  );
};

/**
 * Checks if the paste formatting popup should be shown
 */
export const shouldShowPasteFormattingPopup = (): boolean => {
    try {
        const disabled = localStorage.getItem(PASTE_FORMATTING_POPUP_KEY);
        return disabled !== "true";
    } catch (error) {
        console.error("Error checking paste formatting popup preference:", error);
        return true;
    }
};

/**
 * Shows the paste formatting popup with cleanup message
 */
export const showPasteFormattingPopup = (): Promise<void> => {
    return new Promise((resolve) => {
        let dontShowAgain = false;

        const handleDontShowAgainChange = (checked: boolean) => {
            dontShowAgain = checked;
        };

        Dialog({
            title: "Formatting Cleaned",
            content: (
                <PasteFormattingContent onDontShowAgainChange={handleDontShowAgainChange} />
            ),
            rightBtn: {
                type: "at-primary",
                children: "OK",
                onClick: () => {
                    if (dontShowAgain) {
                        try {
                            localStorage.setItem(PASTE_FORMATTING_POPUP_KEY, "true");
                        } catch (error) {
                            console.error("Error saving paste formatting popup preference:", error);
                        }
                    }
                    resolve();
                }
            },
            hideClose: true
        });
    });
}; 